export default "__VITE_ASSET__TNH01zDI__"